import { CommonModule, DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';

/**
 * Componente PolicyStartDateComponent
 * Muestra la fecha de inicio de la póliza de seguro
 * @component
 */
@Component({
  selector: 'app-policy-start-date',
  standalone: true,
  imports: [CommonModule, DatePipe],
  templateUrl: './policy-start-date.component.html',
  styleUrl: './policy-start-date.component.scss',
})
export class PolicyStartDateComponent {
  /**
   * Fecha de inicio de la póliza (como signal input)
   */
  startDate = input(new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' })));
}
